import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import {
  TAB_BUTTON_DESIGN_HEIGHT,
  TAB_BUTTON_DESIGN_WIDTH,
  TAB_BUTTON_FILLED_PATH_D,
  TAB_BUTTON_SLICE_LEFT,
  TAB_BUTTON_SLICE_RIGHT,
  getTabButtonDisplayPixelWidth,
  getTabButtonEffectiveWidth,
  getTabButtonLabelGroupTransform,
  getTabButtonNineSliceMiddleScale,
  getTabButtonNineSliceMinWidth,
  tabButtonSvgAttrs,
} from '../../utils/resolveTabButtonSvgSize'
import { useTabButtonSvgClipPathId } from '../../utils/useTabButtonSvgClipPathId'

function TabButtonFilled({ label, onClick, ultraWide, wide, width }) {
  const effectiveWidth = getTabButtonEffectiveWidth(width, wide, ultraWide)
  const clipId = useTabButtonSvgClipPathId()
  const wPx = getTabButtonDisplayPixelWidth(effectiveWidth)

  if (wPx != null) {
    const w = Math.max(getTabButtonNineSliceMinWidth(), wPx)
    const sx = getTabButtonNineSliceMiddleScale(w)
    return (
      <Fragment key={`tab-button-filled-${label}`}>
        <svg
          aria-label={label}
          height={TAB_BUTTON_DESIGN_HEIGHT}
          role="tab"
          viewBox={`0 0 ${w} ${TAB_BUTTON_DESIGN_HEIGHT}`}
          width={w}
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <clipPath id={`${clipId}-l`}>
              <rect
                height={TAB_BUTTON_DESIGN_HEIGHT}
                width={TAB_BUTTON_SLICE_LEFT}
                x={0}
                y={0}
              />
            </clipPath>
            <clipPath id={`${clipId}-m`}>
              <rect
                height={TAB_BUTTON_DESIGN_HEIGHT}
                width={TAB_BUTTON_SLICE_RIGHT - TAB_BUTTON_SLICE_LEFT}
                x={TAB_BUTTON_SLICE_LEFT}
                y={0}
              />
            </clipPath>
            <clipPath id={`${clipId}-r`}>
              <rect
                height={TAB_BUTTON_DESIGN_HEIGHT}
                width={TAB_BUTTON_DESIGN_WIDTH - TAB_BUTTON_SLICE_RIGHT}
                x={TAB_BUTTON_SLICE_RIGHT}
                y={0}
              />
            </clipPath>
          </defs>
          <g clipPath={`url(#${clipId}-l)`}>
            <path
              className="tab-button-surface"
              d={TAB_BUTTON_FILLED_PATH_D}
              fill="currentColor"
              onClick={onClick}
            />
          </g>
          <g
            clipPath={`url(#${clipId}-m)`}
            transform={`translate(${TAB_BUTTON_SLICE_LEFT},0) scale(${sx},1) translate(${-TAB_BUTTON_SLICE_LEFT},0)`}
          >
            <path
              className="tab-button-surface"
              d={TAB_BUTTON_FILLED_PATH_D}
              fill="currentColor"
              onClick={onClick}
            />
          </g>
          <g
            clipPath={`url(#${clipId}-r)`}
            transform={`translate(${w - TAB_BUTTON_DESIGN_WIDTH},0)`}
          >
            <path
              className="tab-button-surface"
              d={TAB_BUTTON_FILLED_PATH_D}
              fill="currentColor"
              onClick={onClick}
            />
          </g>
          <g>
            <text
              dominantBaseline="middle"
              onClick={onClick}
              textAnchor="middle"
              x="50%"
              y="53%"
            >
              {label}
            </text>
          </g>
        </svg>
      </Fragment>
    )
  }

  return (
    <Fragment key={`tab-button-filled-${label}`}>
      <svg
        {...tabButtonSvgAttrs(effectiveWidth, 'default')}
        aria-label={label}
        role="tab"
        viewBox={`0 0 ${TAB_BUTTON_DESIGN_WIDTH} ${TAB_BUTTON_DESIGN_HEIGHT}`}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          className="tab-button-surface"
          d={TAB_BUTTON_FILLED_PATH_D}
          fill="currentColor"
          onClick={onClick}
        />
        <g
          transform={getTabButtonLabelGroupTransform(effectiveWidth, 'default')}
        >
          <text
            dominantBaseline="middle"
            onClick={onClick}
            textAnchor="middle"
            x="50%"
            y="53%"
          >
            {label}
          </text>
        </g>
      </svg>
    </Fragment>
  )
}

TabButtonFilled.propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func,
  ultraWide: PropTypes.bool,
  wide: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

export default TabButtonFilled
